import type { FormConfig } from '../types/forms';

export const contactFormConfig: FormConfig = {
  id: 'contact',
  formName: 'Contact page enquiry',
  subject: 'New website enquiry — Contact page',
  submitLabel: 'Send Enquiry',
  successTitle: 'Thank you — your enquiry has been submitted.',
  successBody: 'Your message has been received by our form service and forwarded to our inbox.',
  fields: [
    { name: 'name', label: 'Full name', required: true, requiredMessage: 'Please enter your full name.', autoComplete: 'name' },
    { name: 'email', label: 'Email', type: 'email', required: true, requiredMessage: 'Please enter your email address.', autoComplete: 'email' },
    { name: 'organization', label: 'Organization', autoComplete: 'organization' },
    {
      name: 'enquiryType',
      label: 'Enquiry type',
      type: 'select',
      required: true,
      options: ['Hiring enquiry', 'Career opportunities', 'General enquiry'],
    },
    { name: 'message', label: 'Message', type: 'textarea', required: true, requiredMessage: 'Please add a short message.', minLength: 20 },
  ],
};

export const employerFormConfig: FormConfig = {
  id: 'employer',
  formName: 'Employer hiring enquiry',
  subject: 'New employer hiring enquiry',
  submitLabel: 'Send Hiring Enquiry',
  successTitle: 'Thank you — your hiring enquiry has been submitted.',
  successBody: 'Your enquiry has been received by our form service and forwarded to our inbox.',
  fields: [
    { name: 'name', label: 'Full name', required: true, requiredMessage: 'Please enter your full name.', autoComplete: 'name' },
    { name: 'email', label: 'Work email', type: 'email', required: true, requiredMessage: 'Please enter your work email.', autoComplete: 'email' },
    { name: 'organization', label: 'Organization', required: true, requiredMessage: 'Please enter your organization.', autoComplete: 'organization' },
    { name: 'jobTitle', label: 'Your job title', autoComplete: 'organization-title' },
    { name: 'role', label: 'Role you’re hiring for', required: true, requiredMessage: 'Please tell us the role you’re hiring for.' },
    { name: 'location', label: 'Role location' },
    {
      name: 'timing',
      label: 'Hiring timeline',
      type: 'select',
      fullWidth: true,
      options: ['As soon as possible', 'Within 1–3 months', 'In 3+ months', 'Exploring options'],
    },
    {
      name: 'message',
      label: 'Tell us about the role and your priorities',
      type: 'textarea',
      required: true,
      requiredMessage: 'Please add a few details about the role.',
      minLength: 20,
    },
  ],
};

export const candidateFormConfig: FormConfig = {
  id: 'candidate',
  formName: 'Candidate registration of interest',
  subject: 'New candidate registration of interest',
  submitLabel: 'Register Interest',
  successTitle: 'Thank you — your registration has been submitted.',
  successBody: 'Your details have been received by our form service and forwarded to our inbox.',
  fields: [
    { name: 'name', label: 'Full name', required: true, requiredMessage: 'Please enter your full name.', autoComplete: 'name' },
    { name: 'email', label: 'Email', type: 'email', required: true, requiredMessage: 'Please enter your email address.', autoComplete: 'email' },
    { name: 'phone', label: 'Phone', type: 'tel', autoComplete: 'tel' },
    { name: 'currentTitle', label: 'Current or most recent job title', required: true, requiredMessage: 'Please enter your current or most recent job title.', autoComplete: 'organization-title' },
    { name: 'interests', label: 'Roles or sectors of interest', required: true, requiredMessage: 'Please share the roles or sectors you’re interested in.' },
    { name: 'location', label: 'Preferred location(s)' },
    { name: 'linkedin', label: 'LinkedIn profile URL', type: 'url', fullWidth: true },
    {
      name: 'message',
      label: 'Brief summary of your experience and goals',
      type: 'textarea',
      required: true,
      requiredMessage: 'Please add a short summary.',
      minLength: 20,
    },
    {
      name: 'consent',
      label: 'I agree to my details being shared with Rising Talent Partners so I can be considered for relevant opportunities.',
      type: 'checkbox',
      required: true,
      requiredMessage: 'Please confirm to continue.',
    },
  ],
};
